import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title }) {
  const { sanitySeoSettings, sanityGeneralSettings } = useStaticQuery(
    graphql`
      query {
        sanityGeneralSettings(_id: { eq: "generalSettings" }) {
          siteUrl
        }
        sanitySeoSettings(_id: { eq: "seoSettings" }) {
          siteTitle
          metaDesc
          metaTitle
          shareDesc
          shareTitle
          shareGraphic {
            asset {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    `
  )

  const metaDescription = description || sanitySeoSettings.metaDesc
  const metaImage = sanitySeoSettings.shareGraphic.asset.localFile.publicURL

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${sanitySeoSettings.siteTitle}`}
      meta={[
        {
          property: `og:title`,
          content: sanitySeoSettings.metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `business`,
        },
        {
          property: `og:image`,
          content: metaImage,
        },
        {
          property: `og:url`,
          content: sanityGeneralSettings.siteUrl,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `image`,
          content: metaImage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: metaImage,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: `e86h0vxa7n4mfmhxuivf0hy02xn3jh`,
        },
      ].concat(meta)}
    >
      <link rel="preconnect" href="https://www.google-analytics.com" />
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default SEO
